<template>
    <ui-modal ref="modal" size="large" title="Detalle de planificación" @close="actionSetVisibleModalInformacionPlanificacionAnual(false), limpiar()">
        
        <!-- Header -->
        <div class="d-flex align-items-center justify-content-between">

            <!-- Titulos -->
            <div class="d-flex mb-3">
                <!-- Año -->
                <div class="d-flex mr-4">
                    <b>Año: </b>
                    <div class="ml-2" v-text="anio"></div>
                </div>

                <!-- Empresa -->
                <div class="d-flex mr-4">
                    <b>Empresa: </b>
                    <div class="ml-2" v-text="cliente"></div>
                </div>

                <!-- Total anual planificado -->
                <div class="d-flex mr-4">
                    <b>Total anual planificado: </b>
                    <div class="ml-2" v-text="totalAnual"></div>
                </div>
            </div>

            <!-- Botones header -->
            <div class="d-flex mb-3">

                <Button
                    :size="15"
                    color="#2087c3"
                    colorText="#ffffff"
                    tooltip="Agregar puerto destino"
                    icon="fas fa-ship"
                    round
                    :width="35"
                    class="mr-2"
                    @click.native="activeAgregarFila = !activeAgregarFila"
                    traslate
                    :active="activeAgregarFila"
                    :traslateSelected="activeAgregarFila"
                 />

                <actualizar-planificacion-anual-puertos-modal :semanasDelAnio="semanasDelAnio"/>
                <eliminar-planificacion-anual-puertos-modal />

            </div>
        
        </div>

        <!-- Agregar fila -->
        <div v-if="activeAgregarFila" class="d-flex w-100 justify-content-between align-items-center mb-3" 
             style="border: 1px solid greyborder: 1px solid grey; padding: 10px; border-radius: 10px;">

            <!-- Puerto de destino -->
            <div class="d-flex flex-column align-items-center w-100">
                <div>Puerto destino</div> 
                <ui-select class="w-100" has-search placeholder="Seleccionar" searchPlaceholder="Buscar" 
                :options="lista_puertos" :keys="{ value: 'id', label: 'name' }" v-model="podModel" />
            </div>

            <!-- Contenedor -->
            <div class="d-flex flex-column align-items-center w-100 ml-3">
                <div>Contenedor</div>
                <ui-select class="w-100" has-search placeholder="Seleccionar" searchPlaceholder="Buscar" 
                :options="lista_contenedores" :keys="{ value: 'id', label: 'name' }" v-model="contenedoresModel" />
            </div>

            <!-- Tipo producto -->
            <div class="d-flex flex-column align-items-center w-100 ml-3">
                <div>Tipo producto</div> 
                <ui-select class="w-100" has-search placeholder="Seleccionar" searchPlaceholder="Buscar" 
                :options="lista_productos" :keys="{ value: 'id', label: 'name' }" v-model="productosModel" />
            </div>

            <!-- Consignatario(s) -->
            <div class="d-flex flex-column align-items-center w-100 ml-3">
                <div>Consignatario(s)</div> 
                <ui-select class="w-100" has-search placeholder="Seleccionar" searchPlaceholder="Buscar" 
                :options="lista_consignatarios_por_cliente" :keys="{ value: 'id', label: 'name' }" v-model="consignatariosModel" />
            </div>

            <!-- Carga anual -->
            <div class="d-flex flex-column align-items-center w-100 ml-3">
                <div>Carga anual</div> 
                <div style="height:30px !important;height:30px !important;margin-top: 5px;">0</div>
            </div>

            <Button
                v-if="Object.keys(podModel).length"
                :size="15"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Agregar fila"
                icon="fas fa-plus"
                round
                :width="35"
                class="mt-1"
                @click.native="agregarFila()"
                traslate
            />
            
            <Button
                v-else
                :size="15"
                color="#28a745"
                colorText="#ffffff"
                tooltip="Agregar fila"
                icon="fas fa-plus"
                round
                :width="35"
                class="mt-1"
                traslate
                inactive
            />

        </div>

        <!-- Tabs -->
        <ui-tabs fullwidth raised disableRipple>
            <ui-tab key="informacion1" title="Consolidado">
                <consolidado-planificacion-anual-detalle-tab 
                    :data="consolidadoTabDataAux" :totalAnual="totalAnualAux"  :id_tab="0" :semanasDelAnio="semanasDelAnio" />
            </ui-tab>

            <ui-tab key="informacion2" title="Semanas 1 a 13">
                <detalle-planificacion-anual-tabla 
                    :data="primerTabDataAux" :totalPeriodo="primerTabTotalAnual" :headers="hadersPrimerTab" :totales="primerTabSumaColumna" :id_tab="1" />
            </ui-tab>

            <ui-tab key="informacion3" title="Semanas 14 a 26">
                <detalle-planificacion-anual-tabla 
                    :data="segundoTabDataAux" :totalPeriodo="segundoTabTotalAnual" :headers="hadersSegundoTab" :totales="segundoTabSumaColumna" :id_tab="2" />
            </ui-tab>

            <ui-tab key="informacion4" title="Semanas 27 a 39">
                <detalle-planificacion-anual-tabla 
                    :data="tercerTabDataAux" :totalPeriodo="tercerTabTotalAnual" :headers="hadersTercerTab" :totales="tercerTabSumaColumna" :id_tab="3" />
            </ui-tab>

            <ui-tab key="informacion5" :title="`Semanas 40 a ${semanasDelAnio}`">
               <detalle-planificacion-anual-tabla 
                    :data="cuartoTabDataAux" :totalPeriodo="cuartoTabTotalAnual" :headers="hadersCuartoTab" :totales="cuartoTabSumaColumna" :id_tab="4" />
            </ui-tab>
        </ui-tabs>

    </ui-modal>
</template>

<script>

    // Vuex
    import { mapState, mapActions } from "vuex";

    // Moment
    import moment from "moment";

    // Keen UI
    import UiModal from "keen-ui/src/UiModal";
    import UiTabs from "keen-ui/src/UiTabs";
    import UiTab from "keen-ui/src/UiTab";
    import UiSelect  from "keen-ui/src/UiSelect";

    // Componentes
    import Button from '../../common/Button.vue';

    // Vistas
    import DetallePlanificacionAnualTabla from '../../tablas/lineas/DetallePlanificacionAnualTabla.vue';
    import ConsolidadoPlanificacionAnualDetalleTab from '../../tabs/lineas/planificacionAnualDetalleTabs/consolidadoPlanificacionAnualDetalleTab.vue';
    import ActualizarPlanificacionAnualPuertosModal from './planificacionAnual/ActualizarPlanificacionAnualPuertosModal.vue';
    import EliminarPlanificacionAnualPuertosModal from './planificacionAnual/EliminarPlanificacionAnualPuertosModal.vue';
    import { getConsignatariosPorCliente } from '../../../constants/lineas';

    export default {
        props: ['data'],

        components: {
            UiModal,
            UiTabs,
            UiTab,
            UiSelect,
            DetallePlanificacionAnualTabla,
            ConsolidadoPlanificacionAnualDetalleTab,
            ActualizarPlanificacionAnualPuertosModal,
            EliminarPlanificacionAnualPuertosModal,
            Button,
        },

        data() {
            return {
                cliente                     : '',
                anio                        : '',
                consolidadoTabDataAux       : [],
                
                primerTabDataAux            : [],
                primerTabTotalAnual         : 0,
                hadersPrimerTab             : [
                    '',
                    'Puerto destino',
                    'Contenedor',
                    'Tipo producto',
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '10',
                    '11',
                    '12',
                    '13',
                    'Carga',
                    // 'Opciones',
                ],
                primerTabSumaColumna        : [],

                segundoTabDataAux           : [],
                segundoTabTotalAnual        : 0,
                hadersSegundoTab            : [
                    '',
                    'Puerto destino',
                    'Contenedor',
                    'Tipo producto',
                    '14',
                    '15',
                    '16',
                    '17',
                    '18',
                    '19',
                    '20',
                    '21',
                    '22',
                    '23',
                    '24',
                    '25',
                    '26',
                    'Carga',
                    // 'Opciones',
                ],
                segundoTabSumaColumna       : [],

                tercerTabDataAux            : [],
                tercerTabTotalAnual         : 0,
                hadersTercerTab             : [
                    '',
                    'Puerto destino',
                    'Contenedor',
                    'Tipo producto',
                    '27',
                    '28',
                    '29',
                    '30',
                    '31',
                    '32',
                    '33',
                    '34',
                    '35',
                    '36',
                    '37',
                    '38',
                    '39',
                    'Carga',
                    // 'Opciones',
                ],
                tercerTabSumaColumna        : [],

                cuartoTabDataAux            : [],
                cuartoTabTotalAnual         : 0,
                hadersCuartoTab             : [
                    '',
                    'Puerto destino',
                    'Contenedor',
                    'Tipo producto',
                    '40',
                    '41',
                    '42',
                    '43',
                    '44',
                    '45',
                    '46',
                    '47',
                    '48',
                    '49',
                    '50',
                    '51',
                    '52',
                    'Carga',
                    // 'Opciones',
                ],
                cuartoTabSumaColumna        : [],

                semanasDelAnioAux           : 0,
                totalAnual                  : 0,
                semanasDelAnio              : 0,
                totalAnualAux               : 0,

                habilitarEdicionMultiple    : false,
                dataAux                     : [],

                puertosPlanificacion        : [],
                activeAgregarFila           : false,

                // agregar
                contenedoresModel           : [],
                productosModel              : [],
                consignatariosModel         : [],
                podModel                    : [],
                id_cliente                  : '',
                lista_consignatarios_por_cliente : [],
            }
        },

        computed: {
            ...mapState("lineas", ["visibleModalInformacionPlanificacionAnual","puertosSeleccionadosPlanAnual","lista_contenedores","lista_productos",
                                   "lista_consignatarios","lista_puertos","nuevosConsolidadoMultiples","dataAnioSeleccionado","product_selected",
                                   "container_selected","cerrarModalesPlanificacionAnual","annual_plan_id"]),
        },

        methods : {

            ...mapActions("lineas", ['actionSetVisibleModalInformacionPlanificacionAnual','actionSetHabilitarEdicionMultipleAnual','actionSetDataAnioSeleccionado',
                                     'actionSetNuevosConsolidadoMultiples','actionSetNuevosPlanificacionAnualMultiples',
                                     'actionSetCheckPlanificacionAnual']),

            openModal(ref) {

                this.cargarDataAnioSeleccionado(this.data);
                this.$refs[ref].open();
            },

            closeModal(ref) {
                this.$refs[ref].close();
            },

            SegmentacionTabs(data, container_selected, product_selected, annual_plan_id){

                let weeksKeys                 = [];
                let consolidadoTabData        = [];
                let primerTabData             = [];
                let segundoTabData            = [];
                let tercerTabData             = [];
                let cuartoTabData             = [];

                let primerTab                 = [];
                let primerTabTotal            = 0;
                let primerTabTotalAnual       = 0;
                let primerTabDetalle          = [];

                let segundoTab                = [];
                let segundoTabTotal           = 0;
                let segundoTabTotalAnual      = 0;
                let segundoTabDetalle         = [];

                let tercerTab                 = [];
                let tercerTabTotal            = 0;
                let tercerTabTotalAnual       = 0;
                let tercerTabDetalle          = [];

                let cuartoTab                 = [];
                let cuartoTabTotal            = 0;
                let cuartoTabTotalAnual       = 0;
                let cuartoTabDetalle          = [];

                let cargaAnualTotal           = 0;
                let cargaAnual                = 0;

                let semanasDataComplementaria = [];
                this.puertosPlanificacion     = [];

                let semanasTemp = [];

                data.map( (item, index_data) => {
                    
                    let cargaAnualPuerto = 0;

                    const { port_id, weeks, port, container, product, consignee, } = item;

                    weeks.forEach( element => weeksKeys[element.week] = element );

                    semanasTemp.push(weeksKeys);
                    weeksKeys = [];

                    for (let index = 1; index <= this.semanasDelAnio; index++) {

                        if (index <= 13) {

                            if(semanasTemp[index_data][index]){

                                primerTab.push(semanasTemp[index_data][index].annual_qty);

                                cargaAnualPuerto += semanasTemp[index_data][index].annual_qty;
                                primerTabTotal += semanasTemp[index_data][index].annual_qty;

                                semanasDataComplementaria.push({
                                    "annual_planning_id": semanasTemp[index_data][index].annual_planning_id,
                                    "id"                : semanasTemp[index_data][index].id,
                                    "week"              : semanasTemp[index_data][index].week,
                                    "annual_qty"        : semanasTemp[index_data][index].annual_qty
                                });

                            }else{
                                primerTab.push(0);
                                semanasDataComplementaria.push({ "annual_qty" :  0});
                            }
                            
                        }else if(index >= 14 && index <= 26){
                            
                            if(semanasTemp[index_data][index]){

                                segundoTab.push(semanasTemp[index_data][index].annual_qty); 

                                cargaAnualPuerto += semanasTemp[index_data][index].annual_qty;
                                segundoTabTotal  += semanasTemp[index_data][index].annual_qty;

                                semanasDataComplementaria.push({
                                    "annual_planning_id": semanasTemp[index_data][index].annual_planning_id,
                                    "id"                : semanasTemp[index_data][index].id,
                                    "week"              : semanasTemp[index_data][index].week,
                                    "annual_qty"        : semanasTemp[index_data][index].annual_qty
                                });

                            }else{

                                segundoTab.push(0);
                                semanasDataComplementaria.push({ "annual_qty" :  0});

                            }

                        }else if(index >= 27 && index <= 39){
                            
                            if(semanasTemp[index_data][index]){

                                tercerTab.push(semanasTemp[index_data][index].annual_qty);
                                
                                cargaAnualPuerto += semanasTemp[index_data][index].annual_qty;
                                tercerTabTotal += semanasTemp[index_data][index].annual_qty;

                                semanasDataComplementaria.push({
                                    "annual_planning_id": semanasTemp[index_data][index].annual_planning_id,
                                    "id"                : semanasTemp[index_data][index].id,
                                    "week"              : semanasTemp[index_data][index].week,
                                    "annual_qty"        : semanasTemp[index_data][index].annual_qty
                                });

                            }else{

                                tercerTab.push(0);
                                semanasDataComplementaria.push({ "annual_qty" :  0});

                            }

                        }else if(index >= 40){
                            
                            if(semanasTemp[index_data][index]){

                                cuartoTab.push(semanasTemp[index_data][index].annual_qty);
                                
                                cargaAnualPuerto += semanasTemp[index_data][index].annual_qty;
                                cuartoTabTotal += semanasTemp[index_data][index].annual_qty;

                                semanasDataComplementaria.push({
                                    "annual_planning_id": semanasTemp[index_data][index].annual_planning_id,
                                    "id"                : semanasTemp[index_data][index].id,
                                    "week"              : semanasTemp[index_data][index].week,
                                    "annual_qty"        : semanasTemp[index_data][index].annual_qty
                                });

                            }else{

                                cuartoTab.push(0);
                                semanasDataComplementaria.push({ "annual_qty" :  0});

                            }

                        }

                        semanasTemp[index_data][index] && (cargaAnual += semanasTemp[index_data][index].annual_qty);

                    }

                    cargaAnualTotal      += cargaAnual;

                    primerTabTotalAnual  += primerTabTotal;
                    segundoTabTotalAnual += segundoTabTotal;
                    tercerTabTotalAnual  += tercerTabTotal;
                    cuartoTabTotalAnual  += cuartoTabTotal;

                    consolidadoTabData.push({ id: port_id, data : [port, container, product, consignee].concat(cargaAnual) });
                    cargaAnual = 0;

                    primerTabData.push( {id: port_id, data : [port, container, product].concat(primerTab, primerTabTotal) });
                    segundoTabData.push({id: port_id, data : [port, container, product].concat(segundoTab, segundoTabTotal) });
                    tercerTabData.push( {id: port_id, data : [port, container, product].concat(tercerTab, tercerTabTotal) });
                    cuartoTabData.push( {id: port_id, data : [port, container, product].concat(cuartoTab, cuartoTabTotal) });

                    primerTabTotal  = 0;
                    segundoTabTotal = 0;
                    tercerTabTotal  = 0;
                    cuartoTabTotal  = 0;

                    this.puertosPlanificacion.push({
                        id   : index_data,
                        data : [port, container, product, consignee, cargaAnualPuerto].concat(primerTab, segundoTab, tercerTab, cuartoTab),
                        data_complementaria : { port_id: port_id, total: cargaAnualPuerto, weeks : semanasDataComplementaria, container_selected, product_selected, annual_plan_id},
                        new : false
                    });

                    cargaAnualPuerto = 0;
                    semanasDataComplementaria = [];

                    primerTabDetalle.push(primerTab);
                    segundoTabDetalle.push(segundoTab);
                    tercerTabDetalle.push(tercerTab);
                    cuartoTabDetalle.push(cuartoTab);

                    primerTab  = [];
                    segundoTab = [];
                    tercerTab  = [];
                    cuartoTab  = [];

                });

                this.actionSetDataAnioSeleccionado(this.puertosPlanificacion);
                
                this.consolidadoTabDataAux = consolidadoTabData;

                this.totalAnualAux         = cargaAnualTotal;

                this.primerTabDataAux      = primerTabData;
                this.primerTabTotalAnual   = primerTabTotalAnual;
                primerTabData              = [];

                this.segundoTabDataAux     = segundoTabData;
                this.segundoTabTotalAnual  = segundoTabTotalAnual;

                this.tercerTabDataAux      = tercerTabData;
                this.tercerTabTotalAnual   = tercerTabTotalAnual;

                this.cuartoTabDataAux      = cuartoTabData;
                this.cuartoTabTotalAnual   = cuartoTabTotalAnual;

                this.primerTabSumaColumna  = this.obtenerSumaPorColumna(primerTabDetalle);
                this.segundoTabSumaColumna = this.obtenerSumaPorColumna(segundoTabDetalle);
                this.tercerTabSumaColumna  = this.obtenerSumaPorColumna(tercerTabDetalle);
                this.cuartoTabSumaColumna  = this.obtenerSumaPorColumna(cuartoTabDetalle);

            },

            obtenerSumaPorColumna(data){

                if(Object.keys(data).length == 0){
                    return 0;
                }

                const weeks = Object.keys( data[0] ) ;
                    
                let weekTotal = {} ;
                weeks.forEach( week => weekTotal[week] = 0 );
                
                for (const week of weeks ) {
                    let weekTotalTemp = 0;
                    const weekInt = +week ; // El simbolo + transforma un String a Int
                    data.forEach( ptd => weekTotalTemp += +ptd[ weekInt ] );
                    weekTotal[weekInt] = weekTotalTemp;
                }

                return weekTotal;

            },

            agregarFila(){

                let dataAnioSeleccionadoTemp = [];
                dataAnioSeleccionadoTemp = this.dataAnioSeleccionado;

                let semanas = [];
                let valorSemana = [];

                for (let i = 0; i <= this.semanasDelAnio; i++) {
                    semanas.push({annual_qty: 0});
                    valorSemana.push(0);
                }
                  
                let dataTemp = {
                    id   : 0,
                    data : [this.podModel.name, this.contenedoresModel.name, this.productosModel.name,this.consignatariosModel.name].concat(valorSemana),
                    data_complementaria : {
                        annual_plan_id     : this.annual_plan_id,
                        container_selected : this.container_selected,
                        port_id            : this.podModel.id,
                        product_selected   : this.product_selected,
                        total              : 0,
                        weeks              : semanas
                    },
                    new : true,
                }

                dataAnioSeleccionadoTemp.push(dataTemp);
                this.actionSetDataAnioSeleccionado(dataAnioSeleccionadoTemp);
                dataAnioSeleccionadoTemp = [];

                let id = parseInt(this.consolidadoTabDataAux.length + this.nuevosConsolidadoMultiples.length);

                this.actionSetNuevosConsolidadoMultiples({ 
                    'index'               : id,
                    'contenedores'        : this.contenedoresModel, 
                    "productos"           : this.productosModel, 
                    "consignatarios"      : this.consignatariosModel, 
                    "pod"                 : this.podModel
                });

                this.actionSetNuevosPlanificacionAnualMultiples({'index':id,'contenedores':this.contenedoresModel,"productos":this.productosModel,"pod": this.podModel});

                this.podModel = [];

            },

            limpiar(){
                let consolidadoTabDataAux  = this.consolidadoTabDataAux;
                this.consolidadoTabDataAux = [];
                this.consolidadoTabDataAux = consolidadoTabDataAux;
                sessionStorage.removeItem('data_semanas');

                this.actionSetCheckPlanificacionAnual([]);
                this.actionSetDataAnioSeleccionado([]);
            },

            async cargarDataAnioSeleccionado(_new){

                let { data_complementaria } = _new;
                let { ports, container_selected, product_selected, annual_plan_id, client_id } = data_complementaria;

                this.id_cliente = await client_id;

                let sql = await getConsignatariosPorCliente(client_id)

                sql.code == 200 ? (this.lista_consignatarios_por_cliente = sql.data) : (this.lista_consignatarios_por_cliente = []);

                let anioSeleccionado = _new.data[0].toString();

                this.contenedoresModel   = this.container_selected;
                this.productosModel      = this.product_selected;

                this.anio       = _new.data[0];
                this.cliente    = _new.data[1];
                this.totalAnual = _new.data[5];

                if(moment(anioSeleccionado).isLeapYear()){
                    this.semanasDelAnio = 53;

                    this.hadersCuartoTab = [
                        '',
                        'Puerto destino',
                        'Contenedor',
                        'Tipo producto',
                        '40',
                        '41',
                        '42',
                        '43',
                        '44',
                        '45',
                        '46',
                        '47',
                        '48',
                        '49',
                        '50',
                        '51',
                        '52',
                        '53',
                        'Carga',
                        // 'Opciones',
                    ];

                }else{
                    this.semanasDelAnio = 52;

                    this.hadersCuartoTab = [
                        '',
                        'Puerto destino',
                        'Contenedor',
                        'Tipo producto',
                        '40',
                        '41',
                        '42',
                        '43',
                        '44',
                        '45',
                        '46',
                        '47',
                        '48',
                        '49',
                        '50',
                        '51',
                        '52',
                        'Carga',
                        // 'Opciones',
                    ];
                };

                this.SegmentacionTabs(ports, container_selected, product_selected, annual_plan_id);

            }



        },

        watch: {
            visibleModalInformacionPlanificacionAnual: function (_new) {
                _new && this.openModal("modal");
            },

            puertosSeleccionadosPlanAnual : function(_new){

                const { tab_1, tab_2, tab_3, tab_4, tab_5} = _new;

                let tab_1_aux = false;
                let tab_2_aux = false;
                let tab_3_aux = false;
                let tab_4_aux = false;
                let tab_5_aux = false;

                tab_1 ? tab_1_aux = true : tab_1_aux = false;

                tab_2 ? tab_2_aux = true : tab_2_aux = false;
                tab_3 ? tab_3_aux = true : tab_3_aux = false;
                tab_4 ? tab_4_aux = true : tab_4_aux = false;
                tab_5 ? tab_5_aux = true : tab_5_aux = false;

                tab_1_aux || tab_2_aux || tab_3_aux || tab_4_aux || tab_5_aux 
                    ? this.actionSetHabilitarEdicionMultipleAnual(true) 
                    : this.actionSetHabilitarEdicionMultipleAnual(false);

            },

            cerrarModalesPlanificacionAnual : function(_new){
                _new && this.closeModal('modal');
            },

            data : function(_new){
                this.cargarDataAnioSeleccionado(_new);
            }

        },

    }

</script>

<style scoped>

    .select{
        height: 30px !important;
        width: 160px !important;
        padding-left: 10px !important;
    }

</style>